import React from 'react';
import SEO from './SEO';
import Hero from './Hero';
import Portfolio from './Portfolio';
import WorkExperience from './WorkExperience';
import About from './About';
import Contact from './Contact';

function Home() {
    return (
        <>
            <SEO />
            <main>
                <Hero />
                <Portfolio />
                <WorkExperience />
                <About />
                <Contact />
            </main>
        </>
    );
}

export default Home;
